"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TreeSelector_1 = __importDefault(require("../TreeSelector"));
var Section_1 = require("../Section");
var styles_1 = require("./styles");
exports.CountriesSection = function (_a) {
    var data = _a.data, value = _a.value, animationIndex = _a.animationIndex, onChange = _a.onChange;
    return (react_1.default.createElement(Section_1.Section, { title: "Countries operated in", animationIndex: animationIndex },
        react_1.default.createElement(styles_1.InputWrapper, null, "Region"),
        react_1.default.createElement(TreeSelector_1.default, { data: data, name: "updatedGeographies", value: value, onChange: onChange })));
};
//# sourceMappingURL=index.js.map